/**
 * RelatedLinksContent - 相关链接渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';
import { getFixedHuapuLink, normalizeRelatedLinksData } from '../../config/relatedLinks.config';

export default function RelatedLinksContent({ data, mode = 'view', templateType }) {
  if (!data) return null;

  const normalizedData = normalizeRelatedLinksData(data);
  const enabledLinks = normalizedData.links.filter(link => link.enabled !== false);
  if (enabledLinks.length === 0) return null;

  // 数据驱动布局与样式
  const layout = normalizedData.layout || 'grid'; // grid | vertical-card | horizontal-row
  const cs = normalizedData.cardStyle || {};
  const logoSize = Number(normalizedData.logoSize || (layout === 'vertical-card' ? 72 : 36));
  const textColor = cs.textColor || (templateType === 'standard-food-label' ? 'var(--template-text-color)' : '#202124');
  const cardStyle = {
    background: cs.bgColor || 'transparent',
    border: cs.borderWidth ? `${cs.borderWidth}px solid ${cs.borderColor || '#e8eaed'}` : (layout === 'vertical-card' ? '1px solid #e8eaed' : 'none'),
    borderRadius: (cs.radius ?? (layout === 'vertical-card' ? 12 : 8)) + 'px',
    boxShadow: cs.shadow ? '0 6px 16px rgba(0,0,0,0.08)' : (layout === 'vertical-card' ? '0 6px 16px rgba(0,0,0,0.06)' : 'none'),
    padding: (cs.padding ?? (layout === 'vertical-card' ? 16 : 12)) + 'px',
    color: textColor,
    textDecoration: 'none'
  };

  if (layout === 'vertical-card') {
    return (
      <div className="label-content-related-links">
        {enabledLinks.map((link, idx) => {
          const fixedLink = { ...getFixedHuapuLink(), ...link };
          const iconSrc = getProxyUrl(fixedLink.icon);
          return (
            <a key={idx} href={fixedLink.url} target="_blank" rel="noreferrer" className="link-logo-card" style={cardStyle}>
              <img
                src={iconSrc}
                alt={fixedLink.name}
                style={{ width: logoSize, height: logoSize, objectFit: 'contain' }}
                loading="lazy"
              />
              <span className="link-logo-text" style={{ color: textColor }}>{fixedLink.name}</span>
            </a>
          );
        })}
      </div>
    );
  }

  if (layout === 'horizontal-row') {
    return (
      <div className="label-content-related-links">
        {enabledLinks.map((link, idx) => {
          const fixedLink = { ...getFixedHuapuLink(), ...link };
          const iconSrc = getProxyUrl(fixedLink.icon);
          return (
            <a key={idx} href={fixedLink.url} target="_blank" rel="noreferrer" className="related-link-item" style={cardStyle}>
              <img 
                src={iconSrc} 
                alt={fixedLink.name} 
                style={{ width: logoSize, height: logoSize, objectFit: 'contain' }} 
                loading="lazy"
              />
              <span className="link-name" style={{ color: textColor }}>{fixedLink.name}</span>
            </a>
          );
        })}
      </div>
    );
  }

  // 默认：网格
  return (
    <div className="label-content-related-links">
      <div className="links-grid">
        {enabledLinks.map((link, idx) => {
          const fixedLink = { ...getFixedHuapuLink(), ...link };
          return (
          <a key={idx} href={fixedLink.url} className="related-link-item" target="_blank" rel="noreferrer" style={cardStyle}>
            <img src={getProxyUrl(fixedLink.icon)} alt={fixedLink.name} style={{ width: logoSize, height: logoSize, objectFit: 'contain' }} />
            <span className="link-name" style={{ color: textColor }}>{fixedLink.name}</span>
          </a>
        );})}
      </div>
    </div>
  );
}
